import Int64LookupModelBase from '../_generated/modelBases/int64-lookup-model-base';

export default class Int64LookupModel extends Int64LookupModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
